import React, { useEffect, useState } from "react";
import "./ProppedDoorAlertModal.css";
import logger from "./utils/logger";

const ProppedDoorAlertModal = ({
  isOpen,
  onClose,
  deviceId,
  deviceName,
  timestamp,
}) => {
  const [theme] = useState(
    document.body.classList.contains("dark") ? "dark" : "light"
  );
  const [audio] = useState(() => {
    const sound = new Audio("/alarm-sound2.mp3");
    sound.preload = "auto";
    return sound;
  });

  useEffect(() => {
    if (isOpen) {
      // Play the alarm sound when the modal opens
      const playSound = async () => {
        try {
          audio.loop = true;
          await audio.play();
        } catch (error) {
          logger.error("Error playing alarm sound:", error);
          // If the first sound fails, try playing a fallback browser beep
          try {
            const fallbackSound = new Audio(
              "data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBzhyzPfhmUEGIVu98PC1VwwSOZbZ+tx8KQUkYsT0w3QrCDKR3PbariMDQaXm9bx3JAU0jdL5zXwoCRtYuO3mnU8MFku06/ekUA0PQ6bo89GYQAY3ktryynslBS6Gz/LMeicFKHvH8cF2KwZ0x/D725U+EETJ69CBMQIWRf///96VOQYtguv/7J9NECBhzv/zsGUZCzKR6P/efisHKHrN/92aQggwh9f/56dgDCKA0v/qolQNF1rE/+2mTAwXVbj/8KpQDRVQsv/0r1QOFEyu//e0WxAXSqn/+7hfEBhGpP/+vGQSGkKf///AaRMcPpr//8RtFB08lf//yHIVHjiQ///MdhYgNYv//9B7FyIyhv//1H8YJC6B///YgxkkKn3//9yHGiYmeP//4IsaKCN0///kkBsnH2///+iUGysdav//7JgcLRlm///wmRwvFWL//+uSGy8SVf//5okbMAhL///ihBwxA0n//+KEHTMBPf//4IIdNAAx///dgR00ACn//9uEHjUAH///2ogfNgAV///YiyA3AA///9iOIDcACf//15IhOAAC///UlSE6AAD//9OYIjsAAP//0JwiPAAA///NoCM8AAD//8ujJD0AAP//yKYlPgAA///EqSU/AAD//8GsJkAAAP//vq8nQQAA//+7sidCAAD//7m1KEMAAP//trgpRAAA//+zuSpFAAD//7G8KkYAAP//r78rRwAA//+twSxIAAD//6vELUkAAP//qcYtSgAA//+nyS5LAAD//6XLME0AAP//o84xTgAA//+h0DFPAAD//6DSMlAAAP//ntUzUQAA//+c1zRSAAD//5raNVMAAP//mNw2VAAA//+W3zdVAAD//5ThOFYAAP//kuM5VwAA//+Q5TpYAAD//47nO1kAAP//jek8WgAA//+L7D1bAAD//4nuPlwAAP//h/A/XQAA//+F8kBeAAD//4P0QV8AAP//gfZCYAAA//9/+ENhAAD//331RGIAAAAA+/dFYwAAAAD5+UZkAAAAAPf7R2UAAAAa9f1IZgAAAD/z/0lnAAAgZPEBSmgAAEB/7wNLaQAAYKDtBUxqAACAs+sHTWsAAKDM6QlObAAAv+PnC09tAADc+eUNUG4AABcS4w9RbwAAN0fhEVJwAACHXt8TU3EAALNz3RVUcgAA5YbbF1VzAAAQndkZVnQAADyy1xtXdQAAZ8fVHVh2AACSm9MfWXcAAL6u0SFaeAAA6cHPIlt5AABwzM0kXHoAAL3WyyZdewAACODJKF58AABe6ccqX30AALLzxSxgfgAACf3DLmF/AACPBsIwYoAAAP///y9gfwAA////LV5+AAD///8rXH0AAP///ylafAAAYLRyKFh7AAC9TSkuWH8AAMT8QzddgwAAEAAAAAAAAAAAAAAAAAAAAA=="
            );
            fallbackSound.play();
          } catch (fallbackError) {
            logger.error("Fallback sound also failed:", fallbackError);
          }
        }
      };
      playSound();
    }

    // Cleanup function to stop the sound when the modal closes
    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, [isOpen, audio]);

  if (!isOpen) return null;

  const formattedTimestamp = new Date(timestamp).toLocaleString();

  const handleClose = () => {
    audio.pause();
    audio.currentTime = 0;
    onClose();
  };

  return (
    <>
      <div className="propped-door-modal-overlay" />
      <div className={`propped-door-modal ${theme}`}>
        <h2>⚠️!!! DOOR ALERT !!!⚠️</h2>
        <h3>⚠️ Propped Door Detected! ⚠️</h3>
        <p className="centered">A propped door has been detected:</p>

        <table className="device-details">
          <tbody>
            <tr>
              <td>Device Name:</td>
              <td>{deviceName || "Unknown"}</td>
            </tr>
            <tr>
              <td>Device ID:</td>
              <td>{deviceId}</td>
            </tr>
            <tr>
              <td>Time of incident:</td>
              <td>{formattedTimestamp}</td>
            </tr>
          </tbody>
        </table>

        <p className="centered">
          Please check the door and take appropriate action.
        </p>
        <button onClick={handleClose}>I've Got it!</button>
      </div>
    </>
  );
};

export default ProppedDoorAlertModal;
